export const SET_DEVICE_TYPE = "SET_DEVICE_TYPE";
export const SET_MODAL_DATA = "SET_MODAL_DATA";
export const SET_SHOW_MODAL = "SET_SHOW_MODAL";
export const SET_SHOW_LOCATION_PROMPT_OVERLAY = "SET_SHOW_LOCATION_PROMPT_OVERLAY";
export const SET_SHOW_IN_APP_NOTIFICATION_OVERLAY = "SET_SHOW_IN_APP_NOTIFICATION_OVERLAY";
export const SET_IN_APP_NOTIFICATION_OVERLAY_DATA = "SET_IN_APP_NOTIFICATION_OVERLAY_DATA";
export const SET_ELIGIBLE_LOCATIONS = "SET_ELIGIBLE_LOCATIONS";
export const SET_VPT_STATUS = "SET_VPT_STATUS";
export const SET_LOCATION = "SET_LOCATION";
